// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".page_out[data-v-6ddc93f0]{width:100%;text-align:right}.ppp[data-v-6ddc93f0]{margin-bottom:8px}", ""]);
// Exports
module.exports = exports;
